// extracted by mini-css-extract-plugin
export var hero_container = "index-module--hero_container--1d9e8";
export var hero_wrapper = "index-module--hero_wrapper--c3ed3";
export var text_container = "index-module--text_container--78a98";